var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"workbench-cat-logo",style:(_vm.logoStyle),attrs:{"role":"img","aria-label":"AIMason 猫"}})
}
var staticRenderFns = []

export { render, staticRenderFns }